module.exports = __webpack_public_path__ + "img/home-mine.f3763691.png";